import React from 'react'
import Block from '../Block/Block'
import Pager from './Pager'
import styled from 'react-emotion'
import Discuss from '../../Discuss'
import { z } from '../../../style';

const BlockView = styled('div')(({ color }) => ({
  label: 'BlockView',
  cursor: 'zoom-out',
  background: color || '#FFF',
  padding: '30px',
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: z.singleBlock
}))

export default ({
  block,
  backToBoard,
  mode,
  width,
  height,
  backgroundColor
}) => (
  <BlockView
    onClick={e => {
      // only for clicks directly on this element, not children
      if (e.target === e.currentTarget) backToBoard()
    }}
    color={backgroundColor}
  >
    <Block
      location="single"
      block={block}
      layout={{ width, height }}
      cursor="zoom-out" // "a Hacky fix for Safari 10" relies on this
      onClick={backToBoard}
    />

    {!block.embed && (
      <>
        <Pager prev />
        <Pager next />
      </>
    )}

    {/* Discuss */}
    {mode === 'discuss' && <Discuss boardId={block.board} blockId={block.id} />}
  </BlockView>
)
